import { Toast, ToastMessage } from "primereact/toast";
import { useEffect, useRef } from "react";

import { MESSAGE_TYPES, Message, MessageType } from "../components";

let globalToastRef: Toast | null = null;

export interface ToastOptions extends Omit<ToastMessage, "severity"> {
    severity?: MessageType;
}

export const showToast = (message: ToastOptions) => {
    const { severity = MESSAGE_TYPES.INFO, ...toastMessage } = message;

    globalToastRef?.show({
        ...toastMessage,
        closable: false,
        content: ({
            onClose,
        }: {
            message: ToastMessage;
            onClose?: () => void;
        }) => (
            <div className="relative w-full">
                <Message
                    type={severity}
                    className="pr-9"
                    entries={[
                        { title: message.summary, description: message.detail },
                    ]}
                />
                <button
                    onClick={onClose}
                    className="absolute top-1.5 right-1.5 w-6 h-6 flex items-center justify-center rounded-full text-text-500 hover:bg-black/5"
                >
                    <i className="pi pi-times" />
                </button>
            </div>
        ),
    });
};

export const removeToast = (message: ToastMessage) => {
    globalToastRef?.remove(message);
};

export const clearToasts = () => {
    globalToastRef?.clear();
};

export const GlobalToast = () => {
    const ref = useRef<Toast>(null);

    useEffect(() => {
        globalToastRef = ref.current;
        return () => {
            globalToastRef = null;
        };
    }, []);

    return (
        <Toast
            ref={ref}
            pt={{
                message: { className: "bg-transparent! border-0!" },
                content: { className: "p-0! border-0!" },
            }}
        />
    );
};
